import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'guards/login.guard';
import {TreeViewComponent} from './tree-view.component';

const routes: Routes = [
  {path: 'treeview', component: TreeViewComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
  providers: [],
})

export class TreeViewRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-view/tree-view-routing.module.ts